import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { cliente } from '@/lib/cliente';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { toast } from 'sonner';

const ES_PIN = /^\d{4,6}$/;

export function CambiarPinDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (v: boolean) => void;
}) {
  const [actual, setActual] = useState('');
  const [nuevo, setNuevo] = useState('');
  const [confirma, setConfirma] = useState('');

  function limpiar() {
    setActual('');
    setNuevo('');
    setConfirma('');
  }

  const m = useMutation({
    mutationFn: () => cliente.auth.cambiarPin(actual, nuevo),
    onSuccess: () => {
      toast.success('PIN actualizado');
      limpiar();
      onOpenChange(false);
    },
    onError: (e) => toast.error(e instanceof Error ? e.message : 'No se pudo cambiar el PIN'),
  });

  const errorLocal =
    nuevo && !ES_PIN.test(nuevo)
      ? 'El PIN nuevo debe ser 4 a 6 dígitos'
      : nuevo && confirma && nuevo !== confirma
        ? 'El PIN nuevo y la confirmación no coinciden'
        : nuevo && actual && nuevo === actual
          ? 'El PIN nuevo debe ser distinto al actual'
          : '';
  const puede = ES_PIN.test(actual) && ES_PIN.test(nuevo) && nuevo === confirma && !errorLocal;

  return (
    <Dialog
      open={open}
      onOpenChange={(v) => {
        if (!v) limpiar();
        onOpenChange(v);
      }}
    >
      <DialogContent className="sm:max-w-sm">
        <DialogHeader>
          <DialogTitle>Cambiar mi PIN</DialogTitle>
        </DialogHeader>
        <div className="grid gap-3">
          <div className="grid gap-1">
            <Label>PIN actual</Label>
            <Input
              type="password"
              inputMode="numeric"
              autoComplete="current-password"
              value={actual}
              onChange={(e) => setActual(e.target.value.replace(/\D/g, ''))}
              maxLength={6}
            />
          </div>
          <div className="grid gap-1">
            <Label>PIN nuevo (4 a 6 dígitos)</Label>
            <Input
              type="password"
              inputMode="numeric"
              autoComplete="new-password"
              value={nuevo}
              onChange={(e) => setNuevo(e.target.value.replace(/\D/g, ''))}
              maxLength={6}
            />
          </div>
          <div className="grid gap-1">
            <Label>Confirmar PIN nuevo</Label>
            <Input
              type="password"
              inputMode="numeric"
              autoComplete="new-password"
              value={confirma}
              onChange={(e) => setConfirma(e.target.value.replace(/\D/g, ''))}
              maxLength={6}
            />
          </div>
          {errorLocal && <p className="text-destructive text-xs">{errorLocal}</p>}
        </div>
        <DialogFooter>
          <Button variant="ghost" onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          <Button onClick={() => m.mutate()} disabled={!puede || m.isPending}>
            {m.isPending ? 'Guardando…' : 'Guardar'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
